/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Side_LabelInputs */

const en_us2_workout_logging_side_label = /** @type {(inputs: Workout_Logging_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side`)
};

const pt_br2_workout_logging_side_label = /** @type {(inputs: Workout_Logging_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado`)
};

const es_419_workout_logging_side_label = /** @type {(inputs: Workout_Logging_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado`)
};

const pt_pt2_workout_logging_side_label = /** @type {(inputs: Workout_Logging_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado`)
};

const fr_fr2_workout_logging_side_label = /** @type {(inputs: Workout_Logging_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Côté`)
};

const de_de2_workout_logging_side_label = /** @type {(inputs: Workout_Logging_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite`)
};

const it_it2_workout_logging_side_label = /** @type {(inputs: Workout_Logging_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lato`)
};

/**
* | output |
* | --- |
* | "Side" |
*
* @param {Workout_Logging_Side_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_side_label = /** @type {((inputs?: Workout_Logging_Side_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Side_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_side_label(inputs)
	if (locale === "es-419") return es_419_workout_logging_side_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_side_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_side_label(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_side_label(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_side_label(inputs)
	return en_us2_workout_logging_side_label(inputs)
});
export { workout_logging_side_label as "workout-logging.side_label" }